import Material from "../../elements/Material";
import PbrSpecularGlossiness from "./PbrSpecularGlossiness";
export default class PbrSpecularGlossinessMaterial extends Material {
    async parsePbrInputsData(gltfLoader, data) {
        const pbrSpecGlossData = data.extensions['KHR_materials_pbrSpecularGlossiness'];
        this.pbrInputsData = this.pbrSpecularGlossiness = new PbrSpecularGlossiness();
        await this.pbrSpecularGlossiness.parse(gltfLoader, pbrSpecGlossData);
    }
}
